import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import localeText from "../../../../locale";

// Confirmação com resumo do item, para ações que não podem ser desfeitas
const ConfirmActionDialog = ({
  visible,
  title,
  message,
  details = [],
  confirmLabel,
  confirmTone = "primary",
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    visible={visible}
    onHide={() => !loading && onCancel()}
    header={title || localeText("confirmYourAction")}
    draggable={false}
    resizable={false}
    className="admin-confirm"
    style={{ width: "30rem" }}
    breakpoints={{ "640px": "calc(100vw - 2rem)" }}
    footer={
      <div className="admin-confirm__footer">
        <button type="button" className="admin-btn" onClick={onCancel} disabled={loading}>
          {localeText("cancel")}
        </button>
        <button
          type="button"
          className={classNames("admin-btn", `admin-btn--${confirmTone}`)}
          onClick={onConfirm}
          disabled={loading}
          autoFocus
        >
          {loading && <i className="pi pi-spin pi-spinner" aria-hidden="true" />}
          {confirmLabel || localeText("confirm")}
        </button>
      </div>
    }
  >
    {message && <p className="admin-confirm__message">{message}</p>}
    {details.length > 0 && (
      <dl className="admin-confirm__details">
        {details
          .filter((detail) => detail.value !== undefined && detail.value !== null && detail.value !== "")
          .map((detail) => (
            <div key={detail.label} className="admin-confirm__row">
              <dt>{detail.label}</dt>
              <dd>{detail.value}</dd>
            </div>
          ))}
      </dl>
    )}
  </Dialog>
);

export default ConfirmActionDialog;
